import FormInput from "../UI/FormInput";
import i18n from "i18n";

const NameInput = ({ label = i18n.t("common:name"), placeholder = i18n.t("common:name"), id = null, required = true, maxLength = true }) => {
  let attr = {};
  if (maxLength) attr["maxLength"] = 50;
  return <FormInput label={label} placeholder={placeholder} type="text" id={id ? id + "_name" : "name"} autoComplete={id ? id + " name" : "name"} required={required} attr={attr} />;
};
export default NameInput;